import { render } from "./CommentEditForm.vue?vue&type=template&id=7ff88470"
import script from "./CommentEditForm.vue?vue&type=script&lang=js"
export * from "./CommentEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__